import FluidSelect from "../../../../../common/components/FluidSelect";
import { PriceIndex } from "../../../../../requests_cm/gecoReferentialService/types";
import { useMemo } from "react";
import { getSyntheticEvent } from "../../../../../common/utils/getSyntheticEvent";

export interface CurtailabilityIndexInputProps {
	onChange: (event: any) => void;
	currentCurtailabilityPriceIndex?: number;
	priceIndexes: PriceIndex[];
}

export function CurtailabilityIndexInput(
	props: Readonly<CurtailabilityIndexInputProps>
) {
	const availableOptions = useMemo(() => {
		return (props.priceIndexes || []).map((index: PriceIndex) => ({
			value: `${index.id}`,
			label: index.name,
		}));
	}, [props.priceIndexes]);

	return (
		<FluidSelect
			isLabelStatic
			items={availableOptions}
			label={"Price Index"}
			name={"index"}
			// @ts-ignore does not provides an HTMLElement as it should but the value itself
			onChange={(index: number) => {
				props.onChange(getSyntheticEvent("index", index));
				props.onChange(
					getSyntheticEvent(
						"name",
						(availableOptions || []).find(
							(indexOption) => indexOption.value === `${index}`
						)?.label || ""
					)
				);
			}}
			value={`${props.currentCurtailabilityPriceIndex}`}
		/>
	);
}
